import React from 'react';
import type { JsonLandingPage } from '@sy/ssr-types';
import AnimatedLogoList from '~/templates/LandingV2/components/AnimatedLogoList';
import CTARow from '~/components/Marketing/components/CTARow';
import { Translation } from '~/components/Translation';
import SignupEmailPage from '~/scenes/Signup/scenes/SignupEmailPage';
import MainImage from './components/MainImage';
import HeroSection from '../components/HeroSection';
import GettingStartedStepsWrapper from './components/GettingStartedStepsWrapper';
import FeatureGridWrapper from './components/FeatureGridWrapper';
import LearnMoreBlock from './components/LearnMoreBlock';

interface ParticularFeatureInstructionsTemplateProps {
	data: Extract<
		JsonLandingPage,
		{ template: 'particular-feature-instructions' }
	>;
}

const ParticularFeatureInstructionsTemplate: React.FC<
	ParticularFeatureInstructionsTemplateProps
> = ({ data }) => {
	const { content } = data;

	return (
		<div className="particular-feature-instructions-landing-page">
			{content.hero && (
				<HeroSection
					titleKey={content.hero.titleKey}
					subtitleKey={content.hero.subtitleKey}
					showReviews
				/>
			)}
			{content.mainImage?.imageName && (
				<MainImage
					feature={content.feature}
					imageName={content.mainImage.imageName}
				/>
			)}
			<AnimatedLogoList greyBackground />
			{content.gettingStartedSteps && (
				<GettingStartedStepsWrapper
					feature={content.feature}
					gettingStartedSteps={content.gettingStartedSteps}
				/>
			)}
			{content.learnMoreBlocks && (
				<LearnMoreBlock
					feature={content.feature}
					blocks={content.learnMoreBlocks}
				/>
			)}
			{content.featureGrid && (
				<FeatureGridWrapper
					feature={content.feature}
					featureGrid={content.featureGrid}
				/>
			)}
			<CTARow
				title={<Translation tid="landingMainPage.cta.title" />}
				subtitle={<Translation tid="landingMainPage.cta.body" />}
				cta={<SignupEmailPage isLandingPage isCustomLanding />}
			/>
		</div>
	);
};

export default ParticularFeatureInstructionsTemplate;
